import { create } from 'zustand'
import { ISearchOptions } from '../types/ride-types'

interface IRidesStore {
  searchOptions: ISearchOptions;
  selectedRideId: number | null;
  updateSearchOptions: (data: Partial<ISearchOptions>) => void;
  setSelectedRideId: (id: number | null) => void;
}

const useRidesStore = create<IRidesStore>()(
  set => ({
    searchOptions: {
      page: 0,
      per_page: 10,
      search: '',
      from_datetime: null,
      to_datetime: null
    },
    selectedRideId: null,
    updateSearchOptions: data => {
      set(state => ({ searchOptions: {
        ...state.searchOptions,
        page: 0,
        ...data
      } }))
    },
    setSelectedRideId: id => {
      set(() => ({ selectedRideId: id }))
    }
  })
)

export default useRidesStore
